import { siteName, siteTagline, siteIntro, heroStats } from '@/mocks/home';

export default function Hero() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-16 md:pt-20 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>
      <div className="absolute top-20 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 left-10 w-[400px] h-[400px] bg-accent-100/20 rounded-full blur-3xl"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-accent-100/80 text-accent-700 text-xs font-semibold px-4 py-1.5 rounded-full mb-6">
              <i className="ri-fire-line"></i>
              <span>本周热门推荐</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-foreground-900 leading-tight tracking-tight">
              {siteName}
              <span className="block text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-600 mt-3">
                免费高清影视在线观看平台
              </span>
            </h1>

            <p className="text-lg md:text-xl font-medium text-primary-500 mt-4 mb-6">
              {siteTagline}
            </p>

            <div className="max-w-xl mx-auto lg:mx-0">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {siteIntro}
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mt-8">
              {heroStats.map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="text-2xl md:text-3xl font-black text-primary-500">{stat.value}</div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#ranking"
                onClick={(e) => handleClick(e, '#ranking')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 text-sm md:text-base font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                热门榜单
              </a>
              <a
                href="#topics"
                onClick={(e) => handleClick(e, '#topics')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-100 text-foreground-800 text-sm md:text-base font-medium rounded-full hover:bg-background-200 transition-all duration-200 whitespace-nowrap cursor-pointer border border-background-300/60"
              >
                <i className="ri-compass-3-line text-lg"></i>
                探索分类
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex items-center justify-center">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <div className="aspect-[4/5] rounded-2xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=artistic%20cinematic%20composition%20with%20vintage%20film%20projector%20and%20floating%20film%20strips%2C%20warm%20golden%20and%20amber%20lighting%2C%20soft%20bokeh%20background%2C%20creative%20movie%20theme%2C%20elegant%20minimal%20style%2C%20professional%20photography%2C%20clean%20dark%20background%20with%20warm%20highlights%2C%20artistic%20depth%20of%20field&width=800&height=1000&seq=hero-visual-main&orientation=portrait"
                  alt="萝卜影视-免费高清影视在线观看平台主视觉"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-32 h-32 md:w-40 md:h-40 bg-accent-100/60 rounded-2xl -z-10"></div>
              <div className="absolute -top-4 -left-4 w-24 h-24 md:w-32 md:h-32 bg-primary-100/60 rounded-2xl -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}